// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605191404/js/" + chunkId + "." + {"44":"e8acdf66","225":"8749ef8c","481":"2305fcb5","486":"c83a2894","770":"9e4a2e71"}[chunkId] + ".0.05756718585297205.chunk.js";
};